import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { postAssignApplicationUser } from '../../requests/postAssignApplicationUser';

export const useAssignApplicationUser = (definitionName: string) => {
  const queryClient = useQueryClient();
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: assignUser, ...rest } = useMutation({
    mutationFn: ({ uuid, userId }: { uuid: string; userId: string }) =>
      postAssignApplicationUser(constructPost, uuid, definitionName, userId),
    onSuccess: (_, { uuid }) => {
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'assignments'],
      });
    },
  });

  return { assignUser, ...rest };
};
